import { Box, Typography } from "@mui/material";
import SourceCard from "./SourceCard";
import { useTranslation } from "../context/I18nContext";

const SOURCE_KEYS = [
  "social_media",
  "web",
  "scammers",
  "sexual_offenders",
  "videos",
  "police_photos",
  "news_and_blogs",
] as const;

const SearchInfo = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ mt: 6, mb: 4 }}>
      <Typography
        variant="overline"
        sx={{
          display: "block",
          textAlign: "center",
          color: "text.secondary",
          letterSpacing: "0.12em",
          mb: 3,
          fontFamily: '"Inter", sans-serif',
        }}
      >
        {t("sources.section_title")}
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(2, 1fr)",
            sm: "repeat(3, 1fr)",
            md: "repeat(4, 1fr)",
          },
          gap: 2,
        }}
      >
        {SOURCE_KEYS.map((key) => (
          <SourceCard key={key} sourceKey={key} />
        ))}
      </Box>
    </Box>
  );
};

export default SearchInfo;
